import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-tier-tag',
  templateUrl: './tier-tag.component.html',
  imports: [CommonModule]
})
export class TierTagComponent implements OnInit {
  public tier: string;

  constructor() {
    // intentionally empty
  }

  ngOnInit() {
    this.tier = environment.tier === 'prod' ? undefined : environment.tier;
  }
}
